import { useEffect, useState } from "react";

export const useExtendedLoading = (isLoading: boolean, minDuration = 300) => {
  const [showLoading, setShowLoading] = useState(isLoading);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (isLoading) {
      setShowLoading(true);
    } else {
      timer = setTimeout(() => {
        setShowLoading(false);
      }, minDuration);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isLoading, minDuration]);

  return showLoading;
};
